import * as React from "react";

const SvgComponent = ({ color = "#fff", ...props }) => (
  <svg
    width={23}
    height={20}
    fill="none"
    cursor="pointer"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.18 3.143h13.195c.226 0 .406-.243.406-.547 0-.304-.18-.547-.406-.547H9.18c-.225 0-.406.243-.406.547 0 .304.18.547.406.547ZM22.353 9.256H9.179c-.225 0-.406.243-.406.547 0 .304.18.547.406.547h13.196c.226 0 .406-.243.406-.547 0-.304-.203-.547-.428-.547ZM22.353 16.432H9.179c-.225 0-.406.243-.406.547 0 .304.18.547.406.547h13.196c.226 0 .406-.243.406-.547 0-.304-.203-.547-.428-.547ZM5.372 6.944H.75a.545.545 0 0 0-.547.548v4.622c0 .304.243.547.547.547h4.622a.545.545 0 0 0 .548-.547V7.492c-.03-.304-.274-.548-.548-.548ZM.626 5.211H5.37a.502.502 0 0 0 .456-.273.581.581 0 0 0 0-.548L3.454.285a.565.565 0 0 0-.456-.273.502.502 0 0 0-.456.273L.17 4.421a.58.58 0 0 0 0 .547c.091.183.274.243.456.243ZM3.15 13.907a3.05 3.05 0 0 0-3.04 3.041 3.05 3.05 0 0 0 3.04 3.04 3.05 3.05 0 0 0 3.04-3.04 3.05 3.05 0 0 0-3.04-3.04Z"
      fill={color}
    />
  </svg>
);

export default SvgComponent;